import type { PropsWithChildren } from "react"
import React from "react"
import { useMatch } from "@reach/router"

import WithAuthentication from "~components/shared/with-authentication"
import { ROUTES } from "~utils/helpers/navigation-helpers"

export default function GlobalAuthentication({ children }: PropsWithChildren) {
    const teamMemberOnboardingMatch = useMatch(ROUTES.TEAM_MEMBER_ONBOARDING)
    const billingPortalMatch = useMatch(ROUTES.BILLING_PORTAL)
    const isSignupDefault = Boolean(teamMemberOnboardingMatch)
    // `/billing` now resolves a per-outfitter subscription portal url, so it
    // requires an authenticated outfitter. Only `/billing-portal` (code-based)
    // stays auth-exempt.
    const isAuthExempt = Boolean(billingPortalMatch)

    return (
        <WithAuthentication
            isSignupDefault={isSignupDefault}
            shouldRequireAuth={!isAuthExempt}
        >
            {children}
        </WithAuthentication>
    )
}
